import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F2FF97D8-A51F-4F32-A18A-6A14437EF5CC
 * name lamp-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lamp-outline.svg
 * tags
 * - Home Automation 
 */
export const LampOutlineIcon = createSvgIcon(<><path d="M14.56 4L17.23 12H6.78L9.44 4H14.56M16 2H8L4 14H20L16 2M11 15H13V20H18V22H6V20H11V15Z" /></>, 'LampOutlineIcon');
export default LampOutlineIcon